if (!window.Eurus.loadedScript.has('upsell-only-guard.js')) {
  window.Eurus.loadedScript.add('upsell-only-guard.js');


  // Upsells that cannot be bought individually
  const UPSELL_ONLY_PRODUCT_IDS = [
    9589941764341,
    9340645966069,
    9270936207605,
    9120386941173,
    9120309412085,
    9340638331125
  ];

  let inFlight = false;

  async function enforceUpsellOnlyRule() {
    if (inFlight) return;                       // prevent recursion via the event we re-dispatch
    if (window.updatingCart) {                  // theme already has an in-flight cart write
      await Alpine.store('xCartHelper').waitForCartUpdate();
    }
    inFlight = true;
    try {
      const cart = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' }
      }).then(r => r.json());

      if (!cart || cart.item_count === 0 || cart.items.length !== 1) return;

      const onlyItem = cart.items[0];
      if (!UPSELL_ONLY_PRODUCT_IDS.includes(onlyItem.product_id)) return;

      // Remove the lone upsell-only line and ask Shopify to return the
      // section markup the theme expects, so the UI updates cleanly.
      const sectionIds = Alpine.store('xCartHelper')
                            .getSectionsToRender()
                            .map(s => s.id);

      const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: 1,
          quantity: 0,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      }).then(r => r.json());

      if (res && res.sections) {
        Alpine.store('xCartHelper').reRenderSections(res.sections);
      } else {
        Alpine.store('xMiniCart').reLoad();
      }

      const bubble = document.querySelector('#cart-icon-bubble span');
      Alpine.store('xCartHelper').currentItemCount = bubble ? parseInt(bubble.innerHTML, 10) : 0;

      // Optional: let the rest of the theme know the cart changed again.
      // Guarded by inFlight so we don't loop on ourselves.
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (err) {
      console.error('upsell-only-guard:', err);
    } finally {
      inFlight = false;
    }
  }

  // React to every cart mutation the theme already announces.
  document.addEventListener('eurus:cart:items-changed', enforceUpsellOnlyRule);

  // Also run once on load, so a user landing on /cart with a stale lone
  // upsell item gets it removed without having to click anything.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceUpsellOnlyRule);
  } else {
    enforceUpsellOnlyRule();
  }
}